var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.7499H4.5C4.30109 20.7499 4.11033 20.6709 3.96967 20.5302C3.82902 20.3896 3.75 20.1988 3.75 19.9999V15.8093C3.74966 15.7119 3.76853 15.6154 3.80553 15.5253C3.84253 15.4352 3.89694 15.3533 3.96563 15.2843L15.2156 4.03429C15.2854 3.96343 15.3686 3.90715 15.4603 3.86874C15.5521 3.83033 15.6505 3.81055 15.75 3.81055C15.8495 3.81055 15.9479 3.83033 16.0397 3.86874C16.1314 3.90715 16.2146 3.96343 16.2844 4.03429L20.4656 8.21554C20.5365 8.28533 20.5928 8.36851 20.6312 8.46026C20.6696 8.552 20.6894 8.65046 20.6894 8.74992C20.6894 8.84938 20.6696 8.94784 20.6312 9.03958C20.5928 9.13132 20.5365 9.21451 20.4656 9.28429L9 20.7499Z",
    stroke: "#4BC3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.75H9",
    stroke: "#4BC3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.5L18 11.75",
    stroke: "#4BC3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f867b9a81076d2c2451fb9b9435144d7.svg";
export { ForwardRef as ReactComponent };